import React, { useMemo, useRef, useState } from "react"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { useSelector, useDispatch } from "react-redux"
import { isObject } from "lodash"
import Select from "react-select"
import { getProviderItems } from "store/provider-dashboard/provider-dashboard-action"
import {
  getProviderConsumptionsFacilities,
  getProviderConsumptionsIPs,
  getProviderConsumptionsProvince,
} from "store/provider-consumption/province-consumption-action"
import { providerReportsAction } from "store/provider-reports/p-report-slice"
import { providerConsumptionAction } from "store/provider-consumption/province-consumption-slice"
import {
  getSelectedValues,
  searchObjectValueManager,
  setAllLabelToSelectBoxOption,
} from "utils/utils"

const ProviderConsumptionReporFilter2 = ({
  onAdvancedSearchSubmit,
  loading,
  error,
}) => {
  const dateFlatpickerfrom = useRef(null)
  const dateFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [batch_number, setBatchNumber] = useState("")
  const [project, setProject] = useState(null)
  const [province, setProvince] = useState(null)
  const [facility, setFacility] = useState(null)
  const [ip, setIP] = useState(null)
  const [NeededIds, setNeededIds] = useState({})

  const dispatch = useDispatch()

  const [date, setDate] = useState({
    from: null,
    to: null,
  })

  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )
  const projects = useSelector(
    state => state.providerConsumptions.providerConsumpProjects
  )
  const ips = useSelector(
    state => state.providerConsumptions.providerConsumpIPs
  )

  const items = useSelector(state => state.providerDashboard.ProviderItems)

  const provinces = useSelector(
    state => state.providerConsumptions.providerConsumpProvinces
  )

  const facilities = useSelector(
    state => state.providerConsumptions.providerConsumpFacilities
  )

  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  const handleSubmit = () => {
    let data = {}
    const storeToObject = searchObjectValueManager(data)
    data.date = {
      from: date.from ? date.from : null,
      to: date.to ? date.to : null,
    }
    if (item) {
      data.item = item.map(ite => (ite.value ? ite.value : ite))
    }
    storeToObject("items", item)
    storeToObject("categories", category)
    storeToObject("projects", project)
    storeToObject("ips", ip)
    storeToObject("provinces", province)
    storeToObject("facility", facility)
    data.batch_number = batch_number
    onAdvancedSearchSubmit(data)
  }

  const onClearHandler = () => {
    dateFlatpickerfrom.current.flatpickr.clear()
    dateFlatpickerto.current.flatpickr.clear()
    setItem(null)
    setCategory(null)
    setBatchNumber("")
    setDate({ from: null, to: null })
    setProject(null)
    setProvince(null)
    setFacility(null)
    setIP(null)
    dispatch(providerConsumptionAction.resetState())
    onAdvancedSearchSubmit({})
  }

  const onCategoryChangeHandler = cate => {
    const selectedValue = getSelectedValues(cate, categories?.data)
    const ids = selectedValue?.map(val => val.value)
    setCategory(selectedValue)
    dispatch(getProviderItems({ ids: ids }))
  }

  const onItemChangeHandler = item => {
    setItem(getSelectedValues(item, filteredItems))
  }
  const onProjectChangeHandler = proj => {
    setIP("")
    const selectedValue = getSelectedValues(proj, projects?.data)
    const ids = selectedValue?.map(val => val.value)
    setNeededIds(prev => {
      return { ...prev, project_ids: ids }
    })
    setProject(selectedValue)
    dispatch(getProviderConsumptionsIPs({ project_ids: ids }))
  }

  const onIPChangeHandler = ip => {
    const selectedValue = getSelectedValues(ip, ips?.data)
    const ids = selectedValue?.map(val => val.value)
    setNeededIds(prev => {
      return { ...prev, ip_ids: ids }
    })
    setIP(selectedValue)
    dispatch(
      getProviderConsumptionsProvince({
        ip_ids: ids,
        project_ids: NeededIds?.project_ids,
      })
    )
  }

  const onProvinceChangeHandler = prov => {
    const selectedValue = getSelectedValues(prov, provinces?.data)
    const ids = selectedValue?.map(val => val.value)
    setProvince(selectedValue)
    setFacility("")
    dispatch(
      getProviderConsumptionsFacilities({
        ip_ids: NeededIds?.ip_ids,
        province_ids: ids,
        project_ids: NeededIds?.project_ids,
      })
    )
  }

  const onFacilityChangeHandler = value => {
    setFacility(getSelectedValues(value, facilities?.data))
  }

  const onBatchNumberChange = batch_number => {
    setBatchNumber(batch_number.target.value)
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(projects?.data)}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
            {error?.errors?.project?.[0] && (
              <p className="text-danger">{error?.errors?.project?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">IPs</Label>
            {ips?.data && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(ips?.data)}
                value={ip}
                onChange={onIPChangeHandler}
              />
            )}
            {error?.errors?.ip_id?.[0] && (
              <p className="text-danger">{error?.errors?.ip_id?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Provinces</Label>
            {provinces?.data && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(provinces?.data)}
                value={province}
                onChange={onProvinceChangeHandler}
              />
            )}
            {error?.errors?.province?.[0] && (
              <p className="text-danger">{error?.errors?.province?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Facility</Label>
            {facilities?.data && (
              <Select
                options={facilities?.data}
                value={facility}
                isMulti={true}
                onChange={onFacilityChangeHandler}
              />
            )}
            {error?.errors?.facility?.[0] && (
              <p className="text-danger">{error?.errors?.facility?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(categories?.data)}
                value={category}
                onChange={onCategoryChangeHandler}
              />
            )}
            {error?.errors?.category?.[0] && (
              <p className="text-danger">{error?.errors?.category?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(filteredItems)}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
            {error?.errors?.item?.[0] && (
              <p className="text-danger">{error?.errors?.item?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Batch Number</Label>
            <Input
              name="batch_number"
              placeholder="Batch Number"
              type="text"
              onChange={onBatchNumberChange}
              value={batch_number}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">From Date</Label>
            <Flatpickr
              ref={dateFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">To Date</Label>
            <Flatpickr
              ref={dateFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderConsumptionReporFilter2
